var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLucideEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.82485 2.4375H4.09281C3.65845 2.4375 3.24189 2.61005 2.93476 2.91718C2.62762 3.22431 2.45508 3.64088 2.45508 4.07523V15.5393C2.45508 15.9737 2.62762 16.3902 2.93476 16.6974C3.24189 17.0045 3.65845 17.177 4.09281 17.177H15.5569C15.9913 17.177 16.4078 17.0045 16.7149 16.6974C17.0221 16.3902 17.1946 15.9737 17.1946 15.5393V9.80727",
    stroke: "black",
    strokeWidth: 1.2283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0478 2.1494C15.3736 1.82364 15.8154 1.64063 16.2761 1.64062C16.7368 1.64062 17.1786 1.82364 17.5044 2.1494C17.8302 2.47517 18.0132 2.917 18.0132 3.3777C18.0132 3.8384 17.8302 4.28023 17.5044 4.60599L10.124 11.9872C9.92955 12.1815 9.68934 12.3237 9.4255 12.4008L7.0729 13.0886C7.00244 13.1092 6.92775 13.1104 6.85665 13.0922C6.78555 13.074 6.72065 13.037 6.66875 12.9851C6.61685 12.9332 6.57985 12.8683 6.56164 12.7972C6.54342 12.7261 6.54465 12.6514 6.56521 12.5809L7.25305 10.2283C7.33046 9.96468 7.47294 9.72476 7.6674 9.53064L15.0478 2.1494Z",
    stroke: "black",
    strokeWidth: 1.2283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLucideEdit);
export default __webpack_public_path__ + "static/media/lucide_edit.96469f9112fb555a9a59ca668004d09b.svg";
export { ForwardRef as ReactComponent };